import { render, staticRenderFns } from "./UpdateAccountModal.vue?vue&type=template&id=73b22b09"
import script from "./UpdateAccountModal.vue?vue&type=script&lang=js"
export * from "./UpdateAccountModal.vue?vue&type=script&lang=js"
import style0 from "./UpdateAccountModal.vue?vue&type=style&index=0&id=73b22b09&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports